
import { api } from "../api";

/**
 * updateDeviceEventActionByDevice - Function that updates on database an existing avent-action (automatic command)  
 * /devices/event-actions/{deviceId}  
 * method PUT 
 * @async-function
 */
const updateDeviceEventActionByDevice = async (token: string, deviceId: number, actionId: number, status: string) => {
    const response = await api.put(
        `/devices/event-actions/${deviceId}/${actionId}/${status}`, {}, {
             headers: { 'Authorization': `Bearer ${token}` }
        });
    return response;
};
export default updateDeviceEventActionByDevice;
